import React, { useEffect, useState } from 'react';
import TotalSurveyGroup from '../../assets/icons/TotalSurveyGroup.svg';
import TotalActiveSurveyGroup from '../../assets/icons/ToatalActiveSurveyGroup.svg';
import TotalInactiveSurveyGroup from '../../assets/icons/TotalInactiveSurveyGroup.svg';
import { AiOutlineSearch } from 'react-icons/ai';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { RxCross2 } from 'react-icons/rx';
import { styled } from '@mui/material/styles';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { MdDownload, MdDelete } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../Contexts/GlobalContext';
import axios from 'axios';
import { BASE_URL, CustomTablePagination } from '../../Utlils';
import NoData from '../../components/NoData';
import { utils, writeFile } from 'xlsx';
import DeleteModal from '../../components/DeleteModal';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getSurveyGroups, getSurveysForSurveyGroup } from './surveyGroupAction';
import Skeleton from '../../components/Skeleton';
import { Tooltip } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
};

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    marginRight: 0,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#0226BE' : '#0226BE',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

const SurveyGroup = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);
  const [selectRows, setSelectRows] = useState([]);
  const [filters, setFilters] = useState('');
  const [debouncedSurveyGroupFilterText, setDebouncedSurveyGroupFilterText] =
    useState(filters || '');
  const [deleteModal, setDeleteModal] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const { user, setSnackbar, organization, getAllSurveyGroup } =
    useGlobalContext();
  const [inputData, setInputData] = useState({ isActive: true });
  const [debouncedSurveyNumberSearchText, setDebouncedSurveyNumberSearchText] =
    useState(inputData?.surveyNumberSearch || '');
  const {
    data: allSurveyGroups,
    isLoading: allSurveyGroupsLoading,
    isError: allSurveyGroupsError,
  } = useQuery({
    queryKey: [
      'survey-groups',
      organization?.id,
      page,
      rowsPerPage,
      debouncedSurveyGroupFilterText,
    ],
    queryFn: () =>
      getSurveyGroups(
        organization?.id,
        page,
        rowsPerPage,
        debouncedSurveyGroupFilterText
      ),
    staleTime: 10000,
    cacheTime: 15000,
  });

  const {
    data: allSurveys,
    isLoading: allSurveysLoading,
    isError: allSurveysError,
  } = useQuery({
    queryKey: [
      'survey-groups-surveys',
      organization?.id,
      debouncedSurveyNumberSearchText,
    ],
    queryFn: () =>
      getSurveysForSurveyGroup(
        organization?.id,
        debouncedSurveyNumberSearchText
      ),
    staleTime: 10000,
    cacheTime: 15000,
    enabled: open,
  });
  useEffect(() => {
    if (filters !== debouncedSurveyGroupFilterText) {
      const handler = setTimeout(() => {
        if (page !== 0) {
          setPage(0);
        }
        setDebouncedSurveyGroupFilterText(filters);
      }, 500);
      return () => {
        clearTimeout(handler);
      };
    } else {
      const handler = setTimeout(() => {
        setDebouncedSurveyNumberSearchText(inputData?.surveyNumberSearch);
      }, 500);

      return () => {
        clearTimeout(handler);
      };
    }
  }, [inputData?.surveyNumberSearch, filters]);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    let { name, value } = e.target;
    setInputData((prev) => ({ ...prev, [name]: value }));
  };
  const handleCloseModal = (e) => setDeleteModal(false);

  //ADD SURVEY GROUP:
  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${BASE_URL}/survey-group`, {
        ...inputData,
        createdBy: user?.organizationId,
      })
      .then((res) => {
        queryClient.invalidateQueries(['survey-groups', organization?.id]);
        setSnackbar((prev) => ({
          ...prev,
          open: true,
          msg: 'Survey Group Added !',
          severity: 'success',
        }));
        setOpen(false);
        setInputData({ isActive: true });
        getAllSurveyGroup();
      })
      .catch((er) => {
        setSnackbar((prev) => ({
          ...prev,
          open: true,
          msg: 'Something went wrong !',
          severity: 'error',
        }));
        setOpen(false);
      });
  };

  const handleMultiSelectMui = (e, value) => {
    setInputData((prev) => ({ ...prev, surveys: value?.map((d) => d?._id) }));
  };

  //DOWNLOAD TO EXCEL DATA:
  const DownloadToExcel = () => {
    if (allSurveyGroups?.data?.length) {
      if (selectRows?.length) {
        var wb = utils.book_new(),
          ws = utils.json_to_sheet(
            selectRows?.map((data) => {
              const surveyNumbers = data?.surveys
                ?.map((d) => `QID#${d?.surveyNumber}`)
                .join(' ');

              return {
                'Group Name': data?.groupName,
                Description: data?.description,
                Surveys: surveyNumbers,
                Status: data?.isActive ? 'Active' : 'Inactive',
              };
            })
          );
        utils.book_append_sheet(wb, ws, 'Sheet1');
        writeFile(wb, `Survey-Group-Data.xlsx`);
        setSnackbar({
          open: true,
          severity: 'success',
          msg: 'Excel Sheet Downloaded!',
        });
        setSelectRows([]);
      } else {
        var elt = document.getElementById('table-to-xls-DATA');
        let wb = utils.table_to_book(elt, { sheet: 'Sheet JS' });
        setSnackbar({
          open: true,
          severity: 'success',
          msg: 'Excel Sheet Downloaded!',
        });
        return writeFile(wb, `Survey-Group-Data.xlsx`);
      }
    } else {
      setSnackbar({
        open: true,
        severity: 'warning',
        msg: 'No Data to Download!',
      });
    }
  };

  // DELETE SURVEYS:
  const deleteSurveyGroups = async (e) => {
    e.preventDefault();
    try {
      selectRows?.forEach(async (data) => {
        await axios
          .delete(`${BASE_URL}/survey-group/remove/${data?._id}`)
          .then(() => {
            setDeleteModal(false);
            queryClient.invalidateQueries(['survey-groups', organization?.id]);
            setSnackbar((prev) => ({
              open: true,
              msg: 'Survey group Details Deleted Successfully !',
              severity: 'success',
            }));
          });
      });
    } catch (error) {
      setDeleteModal(false);
      setSnackbar((prev) => ({
        open: true,
        msg: 'Something went wrong!',
        severity: 'error',
      }));
    } finally {
      setSelectRows([]);
      await getAllSurveyGroup();
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // console.log("allSurveyGroups=>", allSurveyGroups);
  // console.log("inputData=>", inputData);
  return (
    <div className="w-full flex flex-col gap-6 py-6">
      <div className="w-full flex items-center justify-between pb-4 border-b border-gray-200">
        <div>
          <h1 className="text-[#0226BE] text-[28px] font-[600] mb-1">
            Survey Groups
          </h1>
          <p className="text-gray-600 text-[14px]">Organize and manage your survey groups</p>
        </div>
        <button
          className="bg-[#0226BE] text-white py-2.5 px-5 text-[14px] font-[500] rounded-md hover:bg-[#021ea8] transition-colors"
          onClick={handleOpen}
        >
          Create Survey Group
        </button>
      </div>
      {/* survey card */}
      <div className="w-full grid grid-cols-3 gap-6">
        <div className="bg-white border border-gray-200 rounded-lg py-5 px-6 flex items-center gap-4 hover:border-gray-300 transition-colors">
          <div className="w-12 h-12 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
            <img src={TotalSurveyGroup} alt="" className="w-6 h-6" />
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-[#1a1a1a] font-[600] text-[24px]">
              {allSurveyGroups?.pagination?.totalRecords || 0}
            </h3>
            <p className="text-gray-600 text-[14px] font-[400]">
              Total Survey Groups
            </p>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg py-5 px-6 flex items-center gap-4 hover:border-gray-300 transition-colors">
          <div className="w-12 h-12 rounded-lg bg-green-50 flex items-center justify-center flex-shrink-0">
            <img
              src={TotalActiveSurveyGroup}
              alt=""
              className="w-6 h-6"
            />
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-[#1a1a1a] font-[600] text-[24px]">
              {allSurveyGroups?.data?.filter((d) => d?.isActive)?.length || 0}
            </h3>
            <p className="text-gray-600 text-[14px] font-[400]">
              Active Survey Groups
            </p>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-lg py-5 px-6 flex items-center gap-4 hover:border-gray-300 transition-colors">
          <div className="w-12 h-12 rounded-lg bg-orange-50 flex items-center justify-center flex-shrink-0">
            <img
              src={TotalInactiveSurveyGroup}
              alt=""
              className="w-6 h-6"
            />
          </div>
          <div className="flex flex-col gap-1">
            <h3 className="text-[#1a1a1a] font-[600] text-[24px]">
              {allSurveyGroups?.data?.filter((d) => !d?.isActive)?.length || 0}
            </h3>
            <p className="text-gray-600 text-[14px] font-[400]">
              Inactive Survey Groups
            </p>
          </div>
        </div>
      </div>
      {/* filters row */}
      <div className="bg-white border border-gray-200 rounded-lg p-4 flex items-center justify-end">
        <div className="w-full max-w-[400px] relative">
          <input
            type="text"
            className="w-full border border-gray-300 rounded-md focus:outline-none h-[44px] pl-11 pr-4 text-[14px] focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all hover:border-gray-400 placeholder:text-gray-400"
            placeholder="Search survey groups..."
            onChange={(e) => setFilters(e.target.value)}
            value={filters}
          />
          <span className="absolute top-1/2 -translate-y-1/2 left-3.5 text-gray-400">
            <AiOutlineSearch size={18} />
          </span>
        </div>
      </div>
      {/* table  */}
      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
        {selectRows?.length > 0 && (
          <div className="w-full border-b border-gray-200 flex items-center justify-between px-6 py-4 bg-blue-50">
            <div className="flex items-center gap-4">
              <input
                type="checkbox"
                className="w-4 h-4 cursor-pointer accent-[#0226BE]"
                checked={selectRows?.length === allSurveyGroups?.data?.length}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectRows(allSurveyGroups?.data);
                  } else {
                    setSelectRows([]);
                  }
                }}
              />
              <span className="text-[14px] text-[#0226BE] font-[500]">
                {selectRows?.length} selected
              </span>
            </div>
            <div className="flex items-center gap-3">
              <button
                className="p-2 hover:bg-gray-100 rounded-md transition-colors"
                onClick={(e) => {
                  DownloadToExcel();
                }}
                title="Download"
              >
                <MdDownload size={20} className="text-gray-600" />
              </button>
              <button
                className="p-2 hover:bg-red-50 rounded-md transition-colors"
                onClick={(e) => {
                  if (selectRows?.length) {
                    setDeleteModal(true);
                  } else {
                    setSnackbar((prev) => ({
                      open: true,
                      msg: 'Please Select at least one survey group to delete!',
                      severity: 'warning',
                    }));
                  }
                }}
                title="Delete"
              >
                <MdDelete size={20} className="text-red-600" />
              </button>
            </div>
          </div>
        )}
        <div className="w-full overflow-x-auto containerScroll">
          <table
            className="whitespace-nowrap text-left w-full"
            id="table-to-xls-DATA"
          >
            <thead className="bg-gray-50 sticky top-0">
              <tr>
                <th className="text-gray-700 text-[14px] font-[600] px-4 py-3 w-12">
                  <input
                    type="checkbox"
                    className="w-4 h-4 cursor-pointer accent-[#0226BE]"
                    checked={selectRows?.length === allSurveyGroups?.data?.length && allSurveyGroups?.data?.length > 0}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectRows(allSurveyGroups?.data);
                      } else {
                        setSelectRows([]);
                      }
                    }}
                  />
                </th>
                <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                  Group Name
                </th>
                <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                  Description
                </th>
                <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                  Surveys
                </th>
                <th className="text-gray-700 text-[14px] font-[600] px-4 py-3">
                  Status
                </th>
              </tr>
            </thead>

              <tbody>
                {allSurveyGroupsLoading ? (
                  <>
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((d, i) => (
                      <tr key={i}>
                        <td className="p-3 text-[#667085]  ">
                          <Skeleton className="w-[50px] h-[30px] rounded-md" />
                        </td>
                        {[1, 2, 3, 4]?.map((dd, ii) => (
                          <td className="p-3 ">
                            <Skeleton
                              key={ii}
                              className="w-[170px] h-[30px] rounded-md"
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </>
                ) : allSurveyGroupsError ? (
                  <tr>
                    <td colSpan={5}>
                      <div className="w-full text-center py-6 text-[#666] font-[500] text-[18px] flex items-center justify-center flex-col space-y-5 h-[250px]">
                        <h1 className="text-[#e12121] text-[14px] ml-8 font-[300] tracking-wide flex gap-[10px] items-center">
                          Something went wrong !
                        </h1>
                      </div>
                    </td>
                  </tr>
                ) : allSurveyGroups?.data?.length ? (
                  allSurveyGroups?.data?.map((data, ind) => (
                    <tr
                      key={ind}
                      className="border-b border-gray-100 transition-all cursor-pointer hover:bg-blue-50"
                      onClick={(e) => navigate(`${data?._id}`)}
                    >
                      <td className="px-4 py-4" onClick={(e) => e.stopPropagation()}>
                        <input
                          type="checkbox"
                          className="w-4 h-4 cursor-pointer accent-[#0226BE]"
                          checked={selectRows?.some(
                            (se) => se?._id === data?._id
                          )}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectRows((prev) => [...prev, data]);
                            } else {
                              setSelectRows(
                                selectRows?.filter(
                                  (sc) => sc?._id !== data?._id
                                )
                              );
                            }
                          }}
                        />
                      </td>
                      <td className="px-4 py-4 text-[#1a1a1a] font-[500] text-[14px]">
                        <Tooltip title={data?.groupName}>
                          <h1 className="max-w-[200px] overflow-hidden whitespace-nowrap text-ellipsis">
                            {data?.groupName}
                          </h1>
                        </Tooltip>
                      </td>
                      <td className="px-4 py-4 text-gray-600 font-[400] text-[14px]">
                        <p className="max-w-[300px] text-wrap line-clamp-2">
                          {data?.description || '-'}
                        </p>
                      </td>
                      <td className="px-4 py-4 text-gray-600 font-[400] text-[14px]">
                        <div className="max-w-[400px] flex flex-wrap gap-2">
                          {data?.surveys?.slice(0, 3).map((sdata, idx) => (
                            <span key={idx} className="bg-gray-100 text-gray-700 py-1 px-2.5 rounded-md text-[12px] font-[500]">
                              QID#{sdata?.surveyNumber}
                            </span>
                          ))}
                          {data?.surveys?.length > 3 && (
                            <span className="bg-blue-50 text-[#0226BE] py-1 px-2.5 rounded-md text-[12px] font-[500]">
                              +{data?.surveys?.length - 3} more
                            </span>
                          )}
                          {!data?.surveys?.length && (
                            <span className="text-gray-400">No surveys</span>
                          )}
                        </div>
                      </td>
                      <td className="px-4 py-4">
                        {data?.isActive ? (
                          <span className="inline-flex items-center px-3 py-1 bg-green-50 text-green-700 text-[12px] font-[500] rounded-full border border-green-200">
                            Active
                          </span>
                        ) : (
                          <span className="inline-flex items-center px-3 py-1 bg-orange-50 text-orange-700 text-[12px] font-[500] rounded-full border border-orange-200">
                            Inactive
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5}>
                      <div className="w-full text-center py-6 text-[#666] font-[500] text-[18px] flex items-center justify-center flex-col space-y-5 h-[250px]">
                        <NoData />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
              <CustomTablePagination
                rowsPerPageOptions={[5, 10, 25, 75, 100]}
                sx={{ fontSize: '10px' }}
                count={allSurveyGroups?.pagination?.totalRecords}
                rowsPerPage={rowsPerPage}
                page={page}
                componentsProps={{
                  select: {
                    'aria-label': 'rows per page',
                  },
                  actions: {
                    showFirstButton: true,
                    showLastButton: true,
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </table>
          </div>
        </div>
      {/* create modal*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <div className="w-full flex items-center flex-col bg-white rounded-lg">
              <div className="w-full py-5 px-6 border-b border-gray-200 text-left relative">
                <h1 className="text-[#0226BE] text-[20px] font-[600]">
                  Create Survey Group
                </h1>
                <button
                  className="absolute top-4 right-4 p-1.5 hover:bg-gray-100 rounded-full cursor-pointer transition-colors"
                  onClick={handleClose}
                >
                  <RxCross2 size={18} className="text-gray-600" />
                </button>
              </div>

              <form
                className="w-full py-5 px-6 flex flex-col gap-5"
                onSubmit={handleSubmit}
              >
                <div className="flex flex-col gap-2">
                  <label
                    htmlFor="SurveyName"
                    className="text-[#1a1a1a] text-[14px] font-[500]"
                  >
                    Group Name
                  </label>
                  <input
                    type="text"
                    required
                    name="groupName"
                    onChange={handleChange}
                    value={inputData?.groupName || ''}
                    placeholder="Enter group name"
                    className="border border-gray-300 rounded-md pl-4 pr-4 h-[48px] focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all text-[#1a1a1a] text-[14px] placeholder:text-gray-400 hover:border-gray-400"
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label
                    htmlFor="description"
                    className="text-[#1a1a1a] text-[14px] font-[500]"
                  >
                    Description
                  </label>
                  <textarea
                    className="w-full border border-gray-300 rounded-md pl-4 pt-3 pr-4 pb-3 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-[#0226BE] transition-all resize-none text-[#1a1a1a] text-[14px] hover:border-gray-400"
                    placeholder="Enter description"
                    rows="4"
                    required
                    name="description"
                    onChange={handleChange}
                    value={inputData?.description || ''}
                  ></textarea>
                </div>
                <div className="flex items-center justify-between py-2">
                  <label className="text-[#1a1a1a] text-[14px] font-[500]">
                    Is Active
                  </label>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        sx={{ m: 1 }}
                        checked={inputData?.isActive !== false}
                        onChange={(e) =>
                          setInputData((prev) => ({
                            ...prev,
                            isActive: e.target.checked,
                          }))
                        }
                      />
                    }
                  />
                </div>
                <div className="flex flex-col gap-2">
                  <label className="text-[#1a1a1a] text-[14px] font-[500]">
                    Select Surveys
                  </label>
                  <Autocomplete
                    multiple
                    limitTags={3}
                    id="multiple-limit-tags"
                    required
                    loading={allSurveysLoading}
                    noOptionsText={
                      allSurveysLoading ? 'Loading...' : 'No surveys found'
                    }
                    loadingText="Loading..."
                    options={
                      allSurveysLoading
                        ? []
                        : allSurveysError
                        ? []
                        : allSurveys?.data || []
                    }
                    getOptionLabel={(option) => `QID#${option?.surveyNumber}`}
                    onChange={(a, b) => handleMultiSelectMui(a, b, b?._id)}
                    inputValue={inputData?.surveyNumberSearch || ''}
                    onInputChange={(e, inputValue) =>
                      setInputData((prev) => ({
                        ...prev,
                        surveyNumberSearch: inputValue,
                      }))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search and select surveys..."
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '6px',
                            '&:hover fieldset': {
                              borderColor: '#9ca3af',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#0226BE',
                            },
                          },
                        }}
                      />
                    )}
                    sx={{ width: '100%' }}
                  />
                </div>
                <div className="flex justify-end gap-3 pt-2">
                  <button
                    type="button"
                    onClick={handleClose}
                    className="border-2 border-gray-300 rounded-md py-2.5 px-5 text-[14px] font-[500] text-gray-700 hover:bg-gray-50 transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="bg-[#0226BE] text-white text-[14px] font-[500] rounded-md py-2.5 px-5 hover:bg-[#021ea8] transition-colors"
                  >
                    Create Group
                  </button>
                </div>
              </form>
            </div>
          </Box>
        </Fade>
      </Modal>

      {/* DELETE MODAL */}
      <DeleteModal
        open={deleteModal}
        handleClose={handleCloseModal}
        text={
          selectRows?.length
            ? [...selectRows?.map((data) => data?.groupName)]
            : allSurveyGroups?.data?.map((data) => data?.groupName)
        }
        handleClick={(e) => deleteSurveyGroups(e)}
      />
    </div>
  );
};

export default SurveyGroup;
